module.exports = __webpack_public_path__ + "static/src/content/images/processed/400/Battles-BC.86e0b99.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/400/Battles-BC.jpg
// module id = TD6d
// module chunks = 0